export const LOCAL_STORAGE_KEY_ACCESS_TOKEN = "KEY_ACCESS_TOKEN"
export const LOCAL_STORAGE_KEY_REFRESH_TOKEN = "KEY_REFRESH_TOKEN"

/**
 * JWT에서 페이로드 파싱
 * @param jwt JWT
 * @return 페이로드 데이터
 */
export function parsePayload(jwt){
    var toks = jwt.split('.')
    var base64Url = toks[1]
    var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
    var jsonPayload = decodeURIComponent(Buffer.from(base64, "base64").toString("ascii").split("").map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
    }).join(''))

    return JSON.parse(jsonPayload)
}